import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'risk-free-badge',
  templateUrl: './risk-free-badge.component.html',
  styleUrl: './risk-free-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskFreeBadgeComponent {}
